/* eslint-disable react/prop-types */
import ReactMarkdown from 'react-markdown';
import React from 'react';
import _ from 'lodash';

const YEAR_IDENTIFIER = '[year]';

const markdownToComponent = (input, onClickEvent, renderers = {}) => {
  if (!input) return null;
  let markdownText = input;
  function defaultLinkRenderer(props) {
    const { children, href } = props;
    const linkName = children[0];
    const onClick = _.get(onClickEvent, linkName, () => {});
    return (
      <a href={href} onClick={() => onClick()} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    );
  }

  if (markdownText.includes(YEAR_IDENTIFIER)) {
    markdownText = input.replace(YEAR_IDENTIFIER, new Date().getFullYear().toString());
  }

  return (
    <ReactMarkdown
      source={markdownText}
      escapeHtml
      renderers={{ Link: defaultLinkRenderer, ...renderers }}
    />
  );
};

export default markdownToComponent;
